import { InlineFormatCommand } from './types'

export type TextFormatHotkeyCommand = InlineFormatCommand | 'link'

type TextFormatHotkeySpec = {
  command: TextFormatHotkeyCommand
  key?: string
  code?: string
  shift?: boolean
}

const TEXT_FORMAT_HOTKEY_SPECS: TextFormatHotkeySpec[] = [
  { command: 'bold', key: 'b' },
  { command: 'italic', key: 'i' },
  { command: 'underline', key: 'u' },
  { command: 'strikethrough', key: 's', shift: true },
  { command: 'link', key: 'k' },
  { command: 'code', key: 'e', shift: true },
  { command: 'removeFormat', code: 'Backslash' },
]

const isPrimaryModifierPressed = (event: KeyboardEvent): boolean => {
  return event.ctrlKey || event.metaKey
}

export const getTextFormatModifierLabel = (): string => {
  if (typeof navigator === 'undefined') return 'Ctrl'

  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform) ? '⌘' : 'Ctrl'
}

export const getTextFormatShortcutLabel = (command: TextFormatHotkeyCommand): string => {
  const mod = getTextFormatModifierLabel()

  switch (command) {
  case 'bold':
    return `${mod}+B`
  case 'italic':
    return `${mod}+I`
  case 'underline':
    return `${mod}+U`
  case 'strikethrough':
    return `${mod}+Shift+S`
  case 'link':
    return `${mod}+K`
  case 'code':
    return `${mod}+Shift+E`
  case 'removeFormat':
    return `${mod}+\\`
  default:
    return mod
  }
}

export const resolveTextFormatCommandFromKeyboardEvent = (
  event: KeyboardEvent,
): TextFormatHotkeyCommand | null => {
  if (!isPrimaryModifierPressed(event) || event.altKey) return null

  const key = event.key.toLowerCase()

  for (const spec of TEXT_FORMAT_HOTKEY_SPECS) {
    if (Boolean(spec.shift) !== event.shiftKey) continue

    if (spec.code) {
      if (event.code === spec.code) return spec.command
      continue
    }

    if (!spec.key || key !== spec.key.toLowerCase()) continue
    return spec.command
  }

  return null
}
